module.exports = __webpack_public_path__ + "img/list_5_zh.3d9cf562.png";